// Draw functions
// Main draw process 
// Use current deck infos & drawConfig from YAML
// Example drawConfig = [Story%label%label(5),Ending(2)]
import socket from '../api/socket'
import EE from '../api/eventemitter'

// const roleChecker = (drawRole,playerRole) => {
//     if(drawRole === playerRole){
//         return true
//     }else{
//         return false
//     }
// }

export const drawToMany = (participants,deck, drawConfig,gid) => {
    // console.log(drawConfig)
    // console.log("DRAW TO MANY")
    let dom = []
    // Shared report so a single "insufficient" notice is sent to everyone (instead of
    // one per player). drawLoop stays silent here and just reports back.
    let report = {insufficient: false}
    for(let i = 0; i<participants.length; i++){
        var hand = drawLoop(deck,drawConfig,{silent: true, report})

        let player = {
          uid: participants[i].uid,
          objects: hand,
        }

        dom.push(player);
    }

    // console.log(dom);
    // console.log(deck);

    // All-players draw ran out of cards: notify everyone via Game Notification Action
    if(report.insufficient){
        socket.emit("Game Notification Action", {notification: "insufficient card to drawn", notifyTarget: "All", gid})
    }

    EE.emit("Library Draw to Many",{dom})
    socket.emit("Game Draw To Many",{dom,deck,gid})
}
  
export const drawLoop = (deck,drawConfig,opts = {}) => {
    var regExp = /\(([^)]+)\)/;
    let result = []
    let insufficient = false

    for(let i = 0; i<drawConfig.length; i++){
        let temp = drawConfig[i]
        if(temp.indexOf("%") !== -1){
            let cat = temp.substring(0,temp.indexOf("%"))
            let labels = temp.substring(temp.indexOf("%")+1, temp.indexOf("(")).split("%")

            var matches = regExp.exec(temp)
            let amount = parseInt(matches[1])

            var draw = drawCard(deck,amount,cat,labels)
            if(draw.length < amount){ insufficient = true }
            result.unshift(draw)
        }else{
            let cat = temp.substring(0,temp.indexOf("("))
            let labels = null

            var matches = regExp.exec(temp)
            let amount = parseInt(matches[1])

            var draw = drawCard(deck,amount,cat,labels)
            if(draw.length < amount){ insufficient = true }
            result.unshift(draw)
        }
    }

    let hand = []
    for(let i = 0; i<result.length; i++){
        hand.unshift(...result[i])
    }

    // Not enough cards to fulfil the draw. Don't break the event script flow — just
    // inform the receiver. drawToMany passes {silent:true, report} so it can instead
    // send one Game Notification Action to all players.
    if(insufficient){
        if(opts.report){ opts.report.insufficient = true }
        if(!opts.silent){
            EE.emit("Notification", {title: "Draw Card", msg: "insufficient card to drawn"})
        }
    }

    return hand;
}
  
const drawCard = (arr,n,cat,labels) => {
    // Guard against a missing/empty category so we never read length of undefined
    var categoryToDraw = arr[cat] || [];
    var result = [];

    for(var i = 0; i<n; i++){
        var card = drawOneCard(categoryToDraw,labels)
        // Ran out of cards to draw — stop instead of pushing undefined. The shorter
        // result (result.length < n) is what signals "insufficient" to drawLoop.
        if(card === undefined){ break }
        result.push(card)
    }

    // After draw
    arr[cat] = categoryToDraw;

    return result
}

const drawOneCard = (cards,labels) => {
    var result;

    if(labels){
        // draw specific label from category

        let cardWithSpecificLabel = cards.filter((n)=>{
            return labels.some((et)=> n.label.includes(et) )
        })

        // No card matches the requested label(s) — treat as insufficient
        if(cardWithSpecificLabel.length === 0){ return undefined }

        let r = Math.floor(Math.random() * cardWithSpecificLabel.length);
        result = cardWithSpecificLabel[r]

        // splice process
        // **compare content only - becareful same content
        // FIXME (pre-existing bug): this compares n.content to the whole `result` card
        // object (should be `result.content`), so it never matches. findIndex returns -1
        // and splice(-1, 1) removes the LAST card instead of the drawn one — the drawn
        // labelled card stays in the deck (duplicate risk). Only affects %label draws.
        let index = cards.findIndex((n)=>{return n.content === result})
        cards.splice(index,1)
    }else{
        // Category has run out of cards — treat as insufficient
        if(cards.length === 0){ return undefined }

        // draw cards from category
        let r = Math.floor(Math.random() * cards.length);

        result = cards[r]

        // splice process
        cards.splice(r,1)
    }

    return result
}

